<template>
	<div>
		<div class="row mt-2">
			<div class="col-12 col-sm-12 col-md-12 col-lg-12">
				<nav class="navbar navbar-breadcrumb navbar-expand-md bg-breadcrumb breadcrumb-borde">
					<div class="mr-auto">
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb clearfix pt-3">
								<li class="breadcrumb-item active">Dashboard Ventas</li>
							</ol>
						</nav>
					</div>
				</nav>
			</div>
		</div>
		<div class="form-row justify-content-center mt-2">
			<Ventas :pListaAnios="listaAnios" :pAnioActual="anioActual" ref="Venta"/>
			<VentasProducto :pListaAnios="listaAnios" :pAnioActual="anioActual" ref="VentaProducto"/>
			<ResumenVentasMensual :pListaAnios="listaAnios" :pAnioActual="anioActual" ref="ResumenVentasMensual"/>
			<CotizacionPropuesta :pListaAnios="listaAnios" :pAnioActual="anioActual" ref="CotizacionPropuesta"/>
			<Oportunidades :pListaAnios="listaAnios" :pAnioActual="anioActual" ref="Oportunidades"/>
			<Vendedores :pListaAnios="listaAnios" :pAnioActual="anioActual" ref="Vendedores"/>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import VueFusionCharts from "vue-fusioncharts";
import FusionCharts from "fusioncharts";
import Column2D from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import Widgets from "fusioncharts/fusioncharts.widgets";

import GammelTheme from "fusioncharts/themes/fusioncharts.theme.gammel";
import CandyTheme from "fusioncharts/themes/fusioncharts.theme.candy";
import ZuneTheme from "fusioncharts/themes/fusioncharts.theme.zune";
import OceanTheme from "fusioncharts/themes/fusioncharts.theme.ocean";
import CarbonTheme from "fusioncharts/themes/fusioncharts.theme.carbon";

Vue.use(
	VueFusionCharts,
	FusionCharts,
	Column2D,
	Widgets,
	FusionTheme,
	GammelTheme,
	CandyTheme,
	ZuneTheme,
	OceanTheme,
	CarbonTheme
);
import Ventas from "./Ventas.vue";
import VentasProducto from "./VentasProducto.vue";
import ResumenVentasMensual from "./ResumenVentasMensual.vue";
import CotizacionPropuesta from "./CotizacionPropuesta.vue";
import Vendedores from "./Vendedores.vue";
import Oportunidades from "./Oportunidades.vue";
export default {
	name:"DashboardVentas",
	components:{Ventas,VentasProducto,ResumenVentasMensual,CotizacionPropuesta,Vendedores,Oportunidades},
	data() {
		return {
			Head: {
				Title: "Dashboard Finanzas",
				BtnNewShow: false,
				BtnNewName: "Nuevo",
				isreturn: false,
				isModal: false,
				isEmit: false,
				Url: "",
				ObjReturn: ""
			},
			isVisible: true,
			listaAnios:[],
			anioActual:''
		}
	},
	methods: {
		async anios() {
			await this.$http.get("funciones/getanios").then(res => {
				//console.log('Calling Years');
				this.listaAnios = res.data.ListaAnios;
				this.anioActual = res.data.AnioActual;
				this.ListVenta();
			});
		},
		ListVenta(){
			this.$refs.Venta.ConfigServicio().then(res => {
				if (res.status) {
					this.ListVentaProducto();
				}
			}).catch(err => {
				console.log('Error en carga de Ventas')
			});
		},
		ListVentaProducto(){
			this.$refs.VentaProducto.GetVentasProducto().then(res => {
				if (res.status) {
					this.ListResumenVentaMensual();
				}
			}).catch(err => {
				console.log('Error en carga de Facturacion')
			});
		},
		ListResumenVentaMensual(){
			this.$refs.ResumenVentasMensual.GetVentaMensual().then(res => {
				if (res.status) {
					this.ListCotizacionPropuesta();
				}
			}).catch(err => {
				console.log('Error en carga de Ventas')
			});
		},
		ListCotizacionPropuesta(){
			this.$refs.CotizacionPropuesta.GetDashboard().then(res => {
				if (res.status) {
					this.ListaVendedor();
				}
			}).catch(err => {
				console.log('Error en carga de Propuestas')
			});
		},
		ListaVendedor(){
			this.$refs.Vendedores.GetDashboard().then(res => {
				if (res.status) {
					this.ContadorOportunidades();
				}
			}).catch(err => {
				console.log('Error en carga de Vendedores')
			});
		},
		ContadorOportunidades(){
			this.$refs.Oportunidades.GetDashboard().then((res) => {
				if (res.status) {
					// this.ContadorOportunidades();
				}
			}).catch(err => {
				console.log('Error en carga de Oportunidades')
			});
		}
	},
	created() {
		this.anios()
	},
}
</script>

<style>

</style>
